export const ANNOUNCE_AMOUNT_COMPARISON_TOLERANCE = 0.000001;

export const DAILY_ANNOUNCE_PERIOD_THRESHOLD_DAYS = 93;

/** 内示登録後モーダルの表示期間(月) */
export const DISPLAY_FORECAST_PERIOD = 6;
